'use client';

import { Box, Button, Link, Typography } from '@mui/material';
import { Route } from 'next';
import { useLogic } from './logic';
import { MuiDialog } from '@/components/dialog/MuiDialog';

export function Footer() {
  const {
    footerElement,
    isOpenDataDialogOpen,
    onClickOpenDataButton,
    handleCloseOpenDataDialog,
  } = useLogic();

  return (
    <Box
      ref={footerElement}
      component="footer"
      sx={{
        position: 'sticky',
        bottom: 0,
        minHeight: '36px',
        width: '100%',
        zIndex: 1201,
        '@media (max-width: 900px)': {
          minHeight: '56px',
        },
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          minHeight: '36px',
          display: 'grid',
          alignItems: 'center',
          width: '100%',
          bgcolor: '#f2f2f2',
          columnGap: 4,
          px: 5,
          flexWrap: 'wrap',
          '@media (max-width: 900px)': {
            columnGap: 0,
            minHeight: '56px',
            px: 3,
          },
        }}
      >
        <Box
          sx={{
            gridRow: 1,
            gridColumn: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            '@media (max-width: 900px)': {
              justifyContent: 'space-evenly',
              gap: 0,
            },
          }}
        >
          <Button
            href={(process.env.NEXT_PUBLIC_TERMS_OF_SERVICE_URL || '') as Route}
            variant="text"
            target="_blank"
            color="inherit"
            sx={{
              color: 'text.secondary',
              fontSize: '14px',
              '@media (max-width: 900px)': { fontSize: '12px' },
            }}
          >
            利用規約
          </Button>
          <Button
            href={(process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL || '') as Route}
            target="_blank"
            color="inherit"
            sx={{
              color: 'text.secondary',
              fontSize: '14px',
              '@media (max-width: 900px)': { fontSize: '12px' },
            }}
          >
            プライバシーポリシー
          </Button>

          <Button
            color="inherit"
            sx={{
              color: 'text.secondary',
              fontSize: '14px',
              '@media (max-width: 900px)': { fontSize: '12px' },
            }}
            onClick={onClickOpenDataButton}
          >
            情報の出典について
          </Button>
          <MuiDialog
            id="open-data-dialog"
            open={isOpenDataDialogOpen}
            handleClose={handleCloseOpenDataDialog}
            dialogTitle=""
            dialogContent={
              <Box>
                <Typography>
                  出典：
                  <Link
                    href="https://www.mhlw.go.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    厚生労働省
                  </Link>
                  の
                  <Link
                    href="https://www.mhlw.go.jp/stf/kaigo-kouhyou_opendata.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    「介護サービス情報の公表システムデータのオープンデータ」
                  </Link>
                  からデータを抽出
                </Typography>
              </Box>
            }
          />
        </Box>
        <Typography
          component="p"
          color="text.secondary"
          sx={{
            gridRow: 1,
            gridColumn: '1 / span 2',
            m: '0 auto',
            fontSize: '14px',
            '@media (max-width: 900px)': {
              gridRow: 2,
              gridColumn: 1,
              pb: 1,
              fontSize: '12px',
            },
          }}
        >
          Copyright© eWeLL Corporation. All right reserved.
        </Typography>
      </Box>
    </Box>
  );
}
